module.exports = __webpack_public_path__ + "img/booBtn.e3292d03.png";